import { z } from 'zod';
/**
 * Fechas señaladas de un cliente.
 *
 * Lo que se pidió no es una fecha de nacimiento: es «el aniversario de la
 * esposa», «la graduación del hijo». Son varias por cliente, cada una con su
 * nombre, y algunas no se repiten.
 */
export const CLIENT_DATE_KINDS = ['CUMPLEANOS', 'ANIVERSARIO', 'SANTO', 'OTRO'];
/** Con cuánta antelación se avisa. Una semana da tiempo a preparar algo. */
export const DIAS_DE_AVISO_FECHA = 7;
export const ClientImportantDateDtoSchema = z.object({
    id: z.string(),
    clientId: z.string(),
    clientName: z.string().optional(),
    contactId: z.string().nullable(),
    contactName: z.string().nullable(),
    label: z.string(),
    kind: z.enum(CLIENT_DATE_KINDS),
    day: z.number().int(),
    month: z.number().int(),
    year: z.number().int().nullable(),
    annual: z.boolean(),
    notes: z.string().nullable(),
    /** Cuándo toca la próxima vez, en ISO. null si ya no vuelve a tocar. */
    proximaOcurrencia: z.string().nullable(),
    /** Y cuántos días faltan. */
    diasHasta: z.number().int().nullable(),
    /** Qué número cumple, si se sabe el año. */
    cumple: z.number().int().nullable(),
});
export const ClientImportantDateListResponseSchema = z.object({
    items: z.array(ClientImportantDateDtoSchema),
});
export const CreateClientImportantDateSchema = z
    .object({
    label: z.string().trim().min(1, 'Ponle un nombre: «Aniversario de boda»').max(120),
    kind: z.enum(CLIENT_DATE_KINDS).default('OTRO'),
    day: z.number().int().min(1).max(31),
    month: z.number().int().min(1).max(12),
    year: z.number().int().min(1900).max(2200).nullable().optional(),
    annual: z.boolean().default(true),
    contactId: z.string().min(1).nullable().optional(),
    notes: z.string().trim().max(500).nullable().optional(),
})
    .refine((d) => {
    // Un día que no existe en ese mes no entra. El 29 de febrero SÍ se admite:
    // es una fecha real, solo que algunos años se celebra el 28.
    const maximos = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return d.day <= maximos[d.month - 1];
}, { message: 'Ese día no existe en ese mes', path: ['day'] })
    .refine((d) => d.annual || !!d.year, {
    // Sin año no se sabe de qué día habla, y el aviso no sabría cuándo saltar.
    message: 'Una fecha que no se repite necesita el año',
    path: ['year'],
});
export const UpdateClientImportantDateSchema = z.object({
    label: z.string().trim().min(1).max(120).optional(),
    kind: z.enum(CLIENT_DATE_KINDS).optional(),
    day: z.number().int().min(1).max(31).optional(),
    month: z.number().int().min(1).max(12).optional(),
    year: z.number().int().min(1900).max(2200).nullable().optional(),
    annual: z.boolean().optional(),
    contactId: z.string().min(1).nullable().optional(),
    notes: z.string().trim().max(500).nullable().optional(),
});
/** Las que vienen pronto, para la agenda y para el aviso. */
export const UpcomingClientDatesResponseSchema = z.object({
    items: z.array(ClientImportantDateDtoSchema),
});
//# sourceMappingURL=client-dates.js.map